import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import ContentWrapper from "../../../Wrapper";
import GatewayAndPriceSidePanel from "../../components/gateway-and-price-side-panel";
import GatewayAndPriceSubheader from "../../components/gateway-and-price-subheader";
import * as gatewayAndPriceActions from "../../store/actions/gateway_and_price_list_actions";

const GATEWAY_AND_PRICE_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function GatewayAndPriceListSms() {
  const tabName = "SMS Pricing";
  const [selectedGatewayAndPriceWithAction, setSelectedGatewayAndPriceWithAction] = useState({
    action: GATEWAY_AND_PRICE_ACTIONS.NONE,
    data: {},
  });
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();

  const gatewayAndPriceList = useSelector((state) => state.gatewayAndPrice.gatewayAndPriceList);

  useEffect(() => {
    dispatch(gatewayAndPriceActions.getListOfGatewayAndPriceRequest({ limit: limit, page: pageNo, search: search }));
  }, [dispatch, limit, pageNo, search]);

  const gatewayAndPriceListTableData = useMemo(() => {
    if (gatewayAndPriceList.loading) return [];
    return gatewayAndPriceList.data.map((v) => {
      return {
        ...v,
        domesticPriceINR: v.price.inr.domestic,
        internationalPriceINR: v.price.inr.international,
        domesticPriceUSD: v.price.usd.domestic,
        internationalPriceUSD: v.price.usd.international,
      };
    });
  }, [gatewayAndPriceList.data, gatewayAndPriceList.loading]);

  return (
    <ContentWrapper subHeader={<GatewayAndPriceSubheader tabName={tabName} >
      <Form.Control placeholder="Search country here..." style={{ width: "300px" }} value={search} onChange={e => setSearch(e.target.value)} />
    </GatewayAndPriceSubheader>}>
      {gatewayAndPriceList.loading ? (
        <ContentWithCardLoading />
      ) : gatewayAndPriceList.data.length === 0 ? (
        "No accounts"
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Route Name", apiKeyName: "routeName", fieldInputType: "INPUT" },
                { title: "Country Name", apiKeyName: "countryName", fieldInputType: "INPUT" },
                // { title: "Country ISO", apiKeyName: "countryIso", fieldInputType: "INPUT" },

                { title: "Domestic Gateway", apiKeyName: "domesticGateway", fieldInputType: "INPUT" },
                { title: "Domestic Price(INR)", apiKeyName: "domesticPriceINR", fieldInputType: "INPUT" },
                { title: "Domestic Price(USD)", apiKeyName: "domesticPriceUSD", fieldInputType: "INPUT" },


                { title: "International Gateway", apiKeyName: "internationalGateway", fieldInputType: "INPUT" },
                { title: "International Price(INR)", apiKeyName: "internationalPriceINR", fieldInputType: "INPUT" },
                { title: "International Price(USD)", apiKeyName: "internationalPriceUSD", fieldInputType: "INPUT" },

                { title: "Regulations", apiKeyName: "regulations", fieldInputType: "SELECT" },
                { title: "Actions", isAction: true, options: ["edit"] },
              ]}
              data={gatewayAndPriceListTableData}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={setPageNo}
              count={gatewayAndPriceList.count}
              // actions
              handleEdit={(data) => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_AND_PRICE_ACTIONS.EDIT, data })}
            />
          </div>
          <GatewayAndPriceSidePanel
            show={selectedGatewayAndPriceWithAction.action === GATEWAY_AND_PRICE_ACTIONS.EDIT}
            gatewayAndPriceData={selectedGatewayAndPriceWithAction.data}
            loadingData={{ limit, page: pageNo }}
            handleClose={() => setSelectedGatewayAndPriceWithAction({ action: GATEWAY_AND_PRICE_ACTIONS.NONE, data: {} })}
          />
        </div>
      )}
    </ContentWrapper>
  );
}
